<ng-container *transloco="let t">
  <p class="label" [ngClass]="{'invalid': IsInValid()}">{{label}}</p>
  <input type="text" class="input" [ngClass]="{'invalid': IsInValid()}" [formControl]="control" [placeholder]="label">
  <div *ngIf="IsInValid()" class="error">
    <img src="/assets/warning.png">
    <p>{{ t('COMMON.INPUT.TEXT.ERROR-PREFIX') }}{{label.toLowerCase()}}</p>
  </div>
</ng-container>
